import React from 'react'

export const KachingLogo = ({ width, height, className }) => (
	<svg width={width} height={height} version="1.1" viewBox="0 0 1163 825.85" xmlns="http://www.w3.org/2000/svg">
		<defs>
			<clipPath id="clipPath22">
				<path d="m0 2e3h2e3v-2e3h-2e3z" />
			</clipPath>
		</defs>
		<g transform="matrix(1.3333 0 0 -1.3333 -751.83 1746.3)">
			<g fill="#ea6657">
				<g transform="translate(654.85 915.24)">
					<path
						d="m0 0h27.652v-9.217l-43.87-52.234 43.87-52.233v-9.218h-27.652l-40.285 48.136h-24.068v-48.136h-26.629v122.9h26.629v-48.137h24.068l15.363 18.264z"
						fill="#ea6657"
					/>
				</g>
				<g clipPath="url(#clipPath22)" fill="#ea6657">
					<g transform="translate(721.42 915.24)">
						<path
							d="m0 0h72.206c7.055 0 13.058-2.476 18.008-7.426 4.952-4.949 7.428-10.899 7.428-17.837v-97.641h-26.801v39.602h-69.645v-39.602h-26.458v97.641c0 7.054 2.445 13.028 7.339 17.923 4.892 4.892 10.867 7.34 17.923 7.34m1.196-56.673h69.645v30.044h-69.645z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(961.08 888.61)">
						<path
							d="m0 0h-96.102v-69.644h96.102v-26.629h-97.298c-7.057 0-13.032 2.444-17.924 7.339-4.893 4.892-7.339 10.865-7.339 17.924v72.376c0 7.055 2.446 13.028 7.339 17.924 4.892 4.891 10.867 7.339 17.924 7.339h97.298z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(1078 915.24)">
						<path
							d="m0 0h26.458v-122.9h-26.458v48.136h-72.547v-48.136h-26.458v122.9h26.458v-48.137h72.547z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<path d="m1124.3 915.24h26.627v-122.9h-26.627z" fillRule="evenodd" />
					<g transform="translate(1267.3 833.31)">
						<path
							d="m0 0v81.936h26.799v-122.9h-27.311l-69.133 82.275v-82.275h-26.456v122.9h27.311z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(1436.1 889.98)">
						<path
							d="m0 0v-11.607h-26.799v10.241h-69.644v-69.644h69.644v18.434h-26.629v26.629h53.428v-46.43c0-6.942-2.474-12.887-7.426-17.836-4.949-4.953-10.952-7.427-18.009-7.427h-72.204c-7.059 0-13.032 2.446-17.923 7.34-4.895 4.892-7.34 10.866-7.34 17.923v72.377c0 7.055 2.445 13.029 7.34 17.923 4.891 4.892 10.864 7.339 17.923 7.339h72.204c7.057 0 13.06-2.475 18.009-7.423 4.952-4.952 7.426-10.899 7.426-17.839"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(935.7 1302)">
						<path
							d="m0 0c0 2.649-0.361 5.196-1.044 7.644h23.676c0.301-2.086 0.502-4.193 0.542-6.36 0.02-0.421 0.02-0.843 0.02-1.284v-85.011c0-6.4-5.197-11.597-11.597-11.597s-11.597 5.197-11.597 11.597z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(1100.1 1309.7)">
						<path
							d="m0 0-19.041-23.194-104.65-127.53c-0.301-0.361-20.987-24.979-27.327-33.306-10.714-14.105-26.766-21.589-42.857-21.589-10.273 0-20.565 3.03-29.514 9.35-13.784 9.711-22.05 25.582-22.11 42.476v146.15c0 2.588 0.2 5.156 0.561 7.644h23.696c-0.682-2.448-1.043-4.996-1.043-7.644v-146.09c0-4.695 1.163-9.23 3.27-13.282 2.107-4.053 5.157-7.585 8.989-10.294 12.76-8.988 30.577-5.778 40.549 7.324 6.682 8.788 27.066 33.045 27.929 34.068l92.495 112.72 19.041 23.194z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(1204.8 1309.7)">
						<path
							d="m0 0c-0.381-0.521-0.782-1.043-1.204-1.545l-17.736-21.649-1.685-2.067c-10.374-12.78-94.021-114.79-108.65-132.84-64.324-79.434-114.04-140.75-120.78-147.79-0.04-0.061-0.1-0.101-0.14-0.161-19.483-19.643-30.758-23.836-39.185-25.341-3.31-0.582-6.561-0.882-9.751-0.882-4.735 0-9.31 0.661-13.704 1.946-21.99 6.5-37.339 27.065-37.339 49.999 0 6.4 5.197 11.597 11.597 11.597 6.42 0 11.617-5.197 11.617-11.597 0-12.721 8.507-24.137 20.706-27.748 3.792-1.124 8.226-1.285 12.801-0.462 2.689 0.482 9.811 1.746 26.705 18.74 4.394 4.654 32.965 39.646 64.687 78.731 0.441 1.244 1.063 2.448 1.946 3.531l151.2 184.35 10.694 13.042c3.11 3.832 5.859 7.223 8.227 10.152z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(958.89 1286.5)">
						<path d="m0 0h-104.25v23.194h104.21l0.02-6.361z" fill="#ea6657" fillRule="evenodd" />
					</g>
					<g transform="translate(1204.8 1309.7)">
						<path
							d="m0 0c-0.381-0.521-0.782-1.043-1.204-1.545l-17.736-21.649h-134.79l19.04 23.194z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(1100.1 977.41)">
						<path
							d="m0 0h-30.016l-19.041 23.194-27.541 33.569c-3.496 4.261-3.51 10.393-0.037 14.671 4.629 5.698 13.317 5.718 17.971 0.045l39.623-48.285z"
							fill="#ea6657"
							fillRule="evenodd"
						/>
					</g>
					<g transform="translate(1204.8 977.41)" fillRule="evenodd">
						<path d="m0 0h-29.995c-2.368 2.929-5.117 6.32-8.227 10.152l-10.694 13.042-80.188 97.77c-3.495 4.263-3.507 10.397-0.028 14.674l0.093 0.115c4.632 5.696 13.322 5.714 17.971 0.03 29.743-36.372 82.354-100.56 90.443-110.52l1.685-2.066 17.736-21.649c0.422-0.502 0.823-1.024 1.204-1.545" />
						<path d="m0 0c-0.381 0.521-0.782 1.043-1.204 1.545l-17.736 21.649h-134.79l19.04-23.194z" />
					</g>
					<g transform="translate(645.89 757.48)">
						<path
							d="m0 0h-66.141c-0.533 0-0.799-0.268-0.799-0.8v-50.49c0-0.533 0.266-0.799 0.799-0.799h66.141v-15.079h-66.141c-4.418 0-8.167 1.542-11.252 4.626-3.084 3.085-4.626 6.834-4.626 11.252v50.49c0 4.416 1.542 8.168 4.626 11.252 3.085 3.084 6.834 4.626 11.252 4.626h66.141z"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(691.35 733.03)">
						<path
							d="m0 0h51.976v23.646c0 0.531-0.268 0.799-0.801 0.799h-50.374c-0.534 0-0.801-0.268-0.801-0.799zm0.801 39.524h50.374c4.417 0 8.187-1.543 11.31-4.627 3.122-3.084 4.684-6.836 4.684-11.251v-66.368h-15.193v27.644h-51.976v-27.644h-15.078v66.368c0 4.415 1.542 8.167 4.627 11.251 3.083 3.084 6.834 4.627 11.252 4.627"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(871.49 756.68)">
						<path
							d="m0 0v-6.283h-15.193v6.283c0 0.532-0.227 0.8-0.685 0.8h-50.49c-0.534 0-0.799-0.268-0.799-0.8v-16.906c0-0.534 0.265-0.8 0.799-0.8h50.49c4.341 0 8.071-1.542 11.195-4.626 3.121-3.084 4.683-6.836 4.683-11.252v-16.906c0-4.418-1.562-8.167-4.683-11.252-3.124-3.084-6.854-4.626-11.195-4.626h-50.49c-4.417 0-8.167 1.542-11.251 4.626-3.085 3.085-4.627 6.834-4.627 11.252v6.283h15.079v-6.283c0-0.533 0.265-0.8 0.799-0.8h50.49c0.458 0 0.685 0.267 0.685 0.8v16.906c0 0.532-0.227 0.8-0.685 0.8h-50.49c-4.417 0-8.167 1.542-11.251 4.626-3.085 3.084-4.627 6.835-4.627 11.252v16.906c0 4.416 1.542 8.167 4.627 11.252 3.084 3.084 6.834 4.626 11.251 4.626h50.49c4.341 0 8.071-1.542 11.195-4.626 3.121-3.085 4.683-6.836 4.683-11.252"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(971.1 772.55)">
						<path
							d="m0 0h15.078v-82.246h-15.078v33.583h-53.917v-33.583h-15.079v82.246h15.079v-33.584h53.917z"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(1084.9 706.19)">
						<path
							d="m0 0v17.705c0 0.458-0.268 0.686-0.801 0.686h-50.374c-0.534 0-0.801-0.228-0.801-0.686v-17.705c0-0.534 0.267-0.8 0.801-0.8h50.374c0.533 0 0.801 0.266 0.801 0.8m-3.999 51.29h-47.176c-0.534 0-0.801-0.269-0.801-0.8v-16.107c0-0.533 0.267-0.799 0.801-0.799h47.176c0.458 0 0.685 0.266 0.685 0.799v16.107c0 0.531-0.227 0.8-0.685 0.8m15.878-0.8v-16.107c0-2.284-0.381-4.226-1.142-5.825 2.97-3.124 4.456-6.74 4.456-10.853v-17.705c0-4.418-1.563-8.168-4.684-11.252-3.124-3.084-6.893-4.626-11.31-4.626h-66.253v82.246h63.055c4.341 0 8.071-1.543 11.194-4.626 3.122-3.085 4.684-6.836 4.684-11.252"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(1146.1 733.03)">
						<path
							d="m0 0h51.976v23.646c0 0.531-0.268 0.799-0.801 0.799h-50.375c-0.533 0-0.8-0.268-0.8-0.799zm0.8 39.524h50.375c4.417 0 8.187-1.543 11.31-4.627 3.122-3.084 4.683-6.836 4.683-11.251v-66.368h-15.192v27.644h-51.976v-27.644h-15.078v66.368c0 4.415 1.542 8.167 4.627 11.251 3.083 3.084 6.833 4.627 11.251 4.627"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(1326.6 757.48)">
						<path
							d="m0 0h-66.139c-0.534 0-0.799-0.268-0.799-0.8v-50.49c0-0.533 0.265-0.799 0.799-0.799h66.139v-15.079h-66.139c-4.418 0-8.168 1.542-11.252 4.626-3.084 3.085-4.626 6.834-4.626 11.252v50.49c0 4.416 1.542 8.168 4.626 11.252s6.834 4.626 11.252 4.626h66.139z"
							fill="#ea6657"
						/>
					</g>
					<g transform="translate(1419.6 772.55)">
						<path
							d="m0 0h16.562v-3.998l-31.07-37.125 31.07-37.125v-3.998h-16.562l-28.101 33.583h-19.42v-33.583h-15.193v82.246h15.193v-33.584h19.42z"
							fill="#ea6657"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
)
